<template>
  <div class="spinner" :class="{ 'loading': loading, 'color': color }">
    <span class="bars">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.spinner {
  display: inline-block;
  position: relative;
  transition: all .2s;
  transition-timing-function: ease-in;
  width: 0;
  height: 2rem;
}

.bars {
  position: absolute;
  top: 50%;
  left: auto;
  right: 1rem;
  margin: -.5em;
  opacity: 0;
  transition-property: padding, opacity;
  transition-duration: .2s, .2s;
  transition-timing-function: ease-in, ease;
  transition-delay: 0s, .2s;
}

.bars span {
  box-sizing: border-box;
  display: inline-block;
  position: absolute;
  right: 0;
  top: .15rem;
  width: 1rem;
  height: 1rem;
  opacity: 1;
  border: 3.4px solid;
  border-color: #fff transparent transparent transparent;
  border-radius: 50%;
  animation: spinner 1.2s cubic-bezier(.5, 0, .5, 1) infinite;
}

.color .bars span {
  border-color: $colorMain transparent transparent transparent;
}


.bars span:nth-child(1) {
  animation-delay: .45s;
}

.bars span:nth-child(2) {
  animation-delay: .3s;
}

.bars span:nth-child(3) {
  animation-delay: .15s;
}

.loading {
  width: 2rem;
}

.loading .bars {
  opacity: 1;
}

.loading .bars span {
  opacity: 1;
}

.spinner:not(.loading) {
  transition-delay: .2s;
}

.spinner:not(.loading) .bars span {
  box-shadow: 0 0 0 .2rem #fff inset;
  border: 7.4px solid transparent;
  transition: all .4s;
}

.spinner.color:not(.loading) .bars span {
  box-shadow: 0 0 0 .2rem $colorMain inset;
}

.spinner:not(.loading) .bars span:nth-child(1) {
  transform: rotate(0deg);
}

.spinner:not(.loading) .bars span:nth-child(2) {
  transform: rotate(90deg);
}

.spinner:not(.loading) .bars span:nth-child(3) {
  transform: rotate(180deg);
}

.spinner:not(.loading) .bars span:nth-child(4) {
  transform: rotate(270deg);
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
